(() => {
  if(window.__RavinLuxuryRefineBooted)return;
  window.__RavinLuxuryRefineBooted=true;
  const instances=new WeakMap();
  const TABS=['TYPE','SIZE','COLOR','PRICE','MORE'];
  const norm=s=>String(s||'').trim().toLowerCase();
  const element=(tag,className,text)=>{
    const el=document.createElement(tag);
    if(className)el.className=className;
    if(text!==undefined)el.textContent=text;
    return el;
  };
  const currencyAmount=n=>String(Math.max(0,Number(n)||0));
  const cleanAmount=x=>{
    const n=Number(String(x??'').trim());
    if(!Number.isFinite(n)||n<0)return null;
    return Math.round(n*100)/100;
  };

  function init(root){
    if(!root||instances.has(root))return;
    const details=root.querySelector('details');
    const panel=details?.querySelector('.ravin-filter-panel');
    const summary=details?.querySelector('summary');
    if(!details||!panel||!summary)return;
    const controller=new AbortController();
    const nativeRows=Array.from(panel.children).filter(el=>el.classList.contains('ravin-filter-row'));
    const optionRows=new Map(TABS.map(k=>[k,[]]));
    let priceRow=null,sortRow=null;
    for(const row of nativeRows){
      const field=row.querySelector('[data-ravin-facet-param]');
      const param=norm(field?.dataset.ravinFacetParam);
      const label=norm(row.querySelector('.ravin-filter-label')?.textContent);
      if(row.querySelector('[data-price-form]')){priceRow=row;continue}
      if(row.querySelector('[data-sort-select]')){sortRow=row;continue}
      let group='MORE';
      if(param==='filter.p.product_type'||label.includes('product type'))group='TYPE';
      else if(param.startsWith('filter.v.option.size')||label.includes('size')||label.includes('waist'))group='SIZE';
      else if(param.startsWith('filter.v.option.color')||param.startsWith('filter.v.option.colour')||label.includes('color')||label.includes('colour'))group='COLOR';
      optionRows.get(group).push(row);
    }

    const url=new URL(window.location.href);
    const initialTabName=(()=>{
      try{return window.sessionStorage.getItem('ravin-refine-tab:'+url.pathname)}catch(e){return null}
    })();
    const facetKeys=new Set();
    for(const opt of root.querySelectorAll('[data-ravin-facet-param]')){
      if(opt.dataset.ravinFacetParam)facetKeys.add(opt.dataset.ravinFacetParam);
    }
    for(const key of url.searchParams.keys()){
      if(key==='filter.p.product_type'||key==='filter.p.vendor'||key==='filter.p.tag'||key.startsWith('filter.v.option.'))facetKeys.add(key);
    }
    const selected=new Map(Array.from(facetKeys,k=>[k,new Set(url.searchParams.getAll(k))]));
    for(const opt of root.querySelectorAll('[data-ravin-facet-param][aria-current="true"]')){
      const k=opt.dataset.ravinFacetParam,v=opt.dataset.ravinFacetValue;
      if(k&&v){if(!selected.has(k))selected.set(k,new Set());selected.get(k).add(v)}
    }
    let currentTab=initialTabName&&TABS.includes(initialTabName)?initialTabName:'TYPE';
    let desiredSort=sortRow?.querySelector('[data-sort-select]')?.value||url.searchParams.get('sort_by')||'';
    let dirty=false;
    const baseMax=url.searchParams.get('ravin.price.lte');
    const baseMin=url.searchParams.get('ravin.price.gte');
    let maximumField=null,minimumField=null,rangeField=null;

    const sumWrap=element('span','rref-summary-right');
    const sumCount=element('span','rref-summary-count');
    const sumIcon=element('span','rref-summary-icon','+');
    sumIcon.setAttribute('aria-hidden','true');
    sumWrap.append(sumCount,sumIcon);
    summary.replaceChildren(element('span','rref-summary-title','REFINE'),sumWrap);

    const nav=element('div','rref-tabs');
    nav.setAttribute('role','tablist');
    nav.setAttribute('aria-label','Refine products');
    const groups=new Map();
    const buttons=new Map();
    const visibleTabs=TABS.filter(k=>k!=='MORE'||optionRows.get('MORE').length>0);
    let uid=0;
    const makeArrow=(direction,track)=>{
      const b=element('button','rref-arrow',direction<0?'←':'→');
      b.type='button';
      b.setAttribute('aria-label',direction<0?'Scroll filter options left':'Scroll filter options right');
      function update(){
        const last=track.scrollWidth-track.clientWidth;
        b.disabled=direction<0?track.scrollLeft<=3:track.scrollLeft>=last-3;
      }
      b.addEventListener('click',()=>{
        track.scrollBy({left:track.clientWidth*.66*direction,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
        window.setTimeout(update,400);
      },{signal:controller.signal});
      track.addEventListener('scroll',update,{passive:true,signal:controller.signal});
      window.addEventListener('resize',update,{passive:true,signal:controller.signal});
      window.requestAnimationFrame(update);
      return b;
    };
    function convertZeroChips(row){
      for(const span of row.querySelectorAll('span.ravin-filter-chip.disabled[data-ravin-facet-param]')){
        const button=element('button',span.className);
        button.type='button';
        for(const a of Array.from(span.attributes)){
          if(a.name==='class'||a.name==='aria-disabled')continue;
          button.setAttribute(a.name,a.value);
        }
        button.append(...Array.from(span.childNodes));
        button.hidden=true;
        span.replaceWith(button);
      }
    }
    function attachLane(row,searchable){
      convertZeroChips(row);
      const strip=row.querySelector('.ravin-filter-chips');
      if(!strip)return;
      const label=row.querySelector('.ravin-filter-label')?.textContent?.trim()||'Filter options';
      strip.setAttribute('role','group');
      strip.setAttribute('aria-label',label);
      row.setAttribute('data-rref-row','');
      if(searchable)row.dataset.rrefSearchable='true';
      const left=makeArrow(-1,strip);
      const right=makeArrow(1,strip);
      row.insertBefore(left,strip);
      strip.insertAdjacentElement('afterend',right);
      if(searchable){
        const find=element('button','rref-search-toggle','⌕');
        find.type='button';find.setAttribute('aria-label','Search product types');
        row.appendChild(find);
        const input=element('input','rref-search');
        input.type='search';input.placeholder='FIND A PRODUCT TYPE';input.setAttribute('aria-label','Search product types');
        input.hidden=true;
        row.insertAdjacentElement('beforebegin',input);
        find.addEventListener('click',()=>{
          input.hidden=!input.hidden;
          if(!input.hidden)input.focus();
          else{input.value='';input.dispatchEvent(new Event('input'));}
        },{signal:controller.signal});
        input.addEventListener('input',()=>{
          const q=norm(input.value);
          for(const chip of strip.querySelectorAll('.ravin-filter-chip')){
            chip.hidden=!!q&&!norm(chip.textContent).includes(q);
          }
          strip.scrollLeft=0;
          strip.dispatchEvent(new Event('scroll'));
          window.requestAnimationFrame(()=>{left.disabled=true;right.disabled=strip.scrollWidth<=strip.clientWidth+3});
        },{signal:controller.signal});
      }
    }

    for(const group of visibleTabs){
      const button=element('button','rref-tab',group);
      button.type='button';
      button.id='RavinRefineTab-'+(++uid)+'-'+Math.random().toString(36).slice(2,6);
      button.setAttribute('role','tab');
      button.setAttribute('aria-selected','false');
      nav.appendChild(button);
      buttons.set(group,button);
      const tabPanel=element('div','rref-panel');
      tabPanel.id=button.id+'-panel';
      tabPanel.setAttribute('role','tabpanel');
      tabPanel.setAttribute('aria-labelledby',button.id);
      tabPanel.dataset.rrefPanel=group;
      button.setAttribute('aria-controls',tabPanel.id);
      groups.set(group,tabPanel);
      button.addEventListener('click',()=>setTab(group),{signal:controller.signal});
      if(group==='PRICE')continue;
      const rows=optionRows.get(group)||[];
      if(!rows.length)tabPanel.appendChild(element('div','rref-empty','NO OPTIONS FOR THIS COLLECTION'));
      for(let i=0;i<rows.length;i++){
        const row=rows[i];
        const key=row.querySelector('.ravin-filter-label')?.textContent?.trim();
        if(group==='MORE'&&key)tabPanel.appendChild(element('div','rref-price-caption',key.toUpperCase()));
        tabPanel.appendChild(row);
        attachLane(row,group==='TYPE'&&i===0);
      }
    }

    if(!groups.has(currentTab))currentTab='TYPE';
    panel.replaceChildren(nav,...Array.from(groups.values()));

    if(priceRow&&groups.has('PRICE')){
      const pricePanel=groups.get('PRICE');
      const layout=element('div','rref-price');
      const sliderArea=element('div','rref-range-wrap');
      sliderArea.appendChild(element('div','rref-price-caption','SLIDE TO SET YOUR MAXIMUM'));
      const slider=element('input','rref-range');
      slider.type='range';slider.min='0';slider.step='50';
      slider.setAttribute('aria-label','Maximum price slider');
      rangeField=slider;
      sliderArea.appendChild(slider);
      const wrap=element('div','rref-price-input-wrap');
      priceRow.classList.add('rref-price-row');
      const form=priceRow.querySelector('[data-price-form]');
      const fields=Array.from(form.querySelectorAll('.ravin-price-field'));
      minimumField=form.querySelector('input[name="filter.v.price.gte"]');
      maximumField=form.querySelector('input[name="filter.v.price.lte"]');
      if(fields[0])fields[0].hidden=true;
      if(fields[1])fields[1].querySelector('label')?.replaceChildren(document.createTextNode('MAX'));
      if(fields[1])fields[1].appendChild(element('span','rref-currency','EGP'));
      wrap.append(priceRow,element('div','rref-price-note','FINAL PRICE AFTER DISCOUNTS'));
      layout.append(sliderArea,wrap);
      pricePanel.appendChild(layout);
      if(maximumField){
        const originalCap=cleanAmount(maximumField.placeholder)||10000;
        const current=cleanAmount(baseMax??maximumField.value);
        slider.max=String(Math.max(1000,originalCap,current||0));
        slider.value=String(Math.min(Number(slider.max),Math.max(0,current??Number(slider.max))));
        if(baseMax!==null)maximumField.value=baseMax;
        if(baseMin!==null&&minimumField)minimumField.value=baseMin;
        slider.addEventListener('input',()=>{maximumField.value=slider.value;dirty=true;renderSummary()},{signal:controller.signal});
        maximumField.addEventListener('input',()=>{
          const v=cleanAmount(maximumField.value);
          if(v!==null){
            if(v>Number(slider.max))slider.max=String(Math.ceil(v/100)*100);
            slider.value=String(v);
          }
          dirty=true;
          renderSummary();
        },{signal:controller.signal});
        form.addEventListener('submit',event=>{
          event.preventDefault();event.stopImmediatePropagation();applyFilters();
        },{capture:true,signal:controller.signal});
      }
    }

    const sortRowInner=sortRow?.querySelector('[data-sort-select]');
    const sort=element('div','rref-sort');
    sort.appendChild(element('span','rref-sort-label','SORT'));
    const sortTrack=element('div','rref-sort-track');
    if(sortRowInner){
      for(const option of Array.from(sortRowInner.options)){
        const b=element('button','rref-sort-choice',option.textContent);
        b.type='button';b.dataset.rrefSortValue=option.value;
        b.setAttribute('aria-pressed',String(option.value===desiredSort));
        b.addEventListener('click',()=>{
          desiredSort=option.value;dirty=true;
          for(const elem of sortTrack.querySelectorAll('[data-rref-sort-value]'))
            elem.setAttribute('aria-pressed',String(elem.dataset.rrefSortValue===desiredSort));
          renderSummary();
          applyFilters();
        },{signal:controller.signal});
        sortTrack.appendChild(b);
      }
    }
    sort.appendChild(sortTrack);
    if(sortTrack.children.length>0)panel.appendChild(sort);
    const footer=element('div','rref-footer');
    const selectionInfo=element('div','rref-summary-line');
    const selectionKey=element('div','rref-summary-key','YOUR EDIT');
    const selectionValues=element('div','rref-summary-values');
    selectionInfo.append(selectionKey,selectionValues);
    const clear=element('button','rref-clear','CLEAR');
    clear.type='button';clear.setAttribute('aria-label','Clear selected filters and price');
    const apply=element('button','rref-apply');
    apply.type='button';
    apply.append(element('span','', 'VIEW RESULTS'),element('span','', '↗'));
    footer.append(selectionInfo,clear,apply);
    panel.appendChild(footer);
    if(sortRow)sortRow.classList.add('rref-hidden-legacy');

    function countSelected(){
      let count=0;
      for(const values of selected.values())count+=values.size;
      if(maximumField&&maximumField.value!==''&&cleanAmount(maximumField.value)!==null)count++;
      if(minimumField&&minimumField.value!==''&&cleanAmount(minimumField.value)!==null)count++;
      return count;
    }
    function renderSummary(){
      const labels=[];
      const found=new Set();
      for(const chip of root.querySelectorAll('.ravin-filter-chips [data-ravin-facet-param]')){
        const p=chip.dataset.ravinFacetParam,v=chip.dataset.ravinFacetValue;
        const picked=!!selected.get(p)?.has(v);
        chip.classList.toggle('active',picked);
        chip.setAttribute('aria-pressed',String(picked));
        chip.setAttribute('aria-current',String(picked));
        chip.removeAttribute('aria-disabled');
        if(picked){const k=p+'::'+v;if(!found.has(k)){found.add(k);labels.push(chip.textContent.trim().replace(/\(\d+\)/,'').trim())}}
      }
      if(maximumField && maximumField.value!==''){
        const priceValue=cleanAmount(maximumField.value);
        if(priceValue!==null)labels.push('UNDER '+priceValue+' EGP');
      }
      sumCount.textContent=countSelected()?countSelected()+' SELECTED':'ALL ITEMS';
      selectionValues.textContent=labels.length?labels.join('  ·  '):'EVERYTHING';
      selectionValues.title=selectionValues.textContent;
      clear.disabled=!countSelected();
      apply.firstElementChild.textContent=dirty?'APPLY FILTERS':'VIEW RESULTS';
    }
    function setTab(tab){
      if(!groups.has(tab))return;
      currentTab=tab;
      for(const [key,p] of groups)p.hidden=key!==tab;
      for(const [key,b] of buttons)b.setAttribute('aria-selected',String(key===tab));
      try{window.sessionStorage.setItem('ravin-refine-tab:'+url.pathname,tab)}catch(e){}
      for(const lane of groups.get(tab).querySelectorAll('.ravin-filter-chips')){
        window.requestAnimationFrame(()=>lane.dispatchEvent(new Event('scroll')));
      }
    }
    root.addEventListener('click',event=>{
      const chip=event.target.closest?.('.ravin-filter-chips [data-ravin-facet-param]');
      if(!chip||!root.contains(chip))return;
      event.preventDefault();event.stopImmediatePropagation();
      const p=chip.dataset.ravinFacetParam,v=chip.dataset.ravinFacetValue;
      if(!p||!v)return;
      const values=selected.get(p)||new Set();
      selected.set(p,new Set(values.has(v)?[]:[v]));
      dirty=true;
      renderSummary();
      applyFilters();
    },{capture:true,signal:controller.signal});

    function applyFilters(){
      if(maximumField&&!maximumField.reportValidity())return;
      if(minimumField&&!minimumField.reportValidity())return;
      const minAmount=!minimumField||minimumField.value===''?null:cleanAmount(minimumField.value);
      const maxAmount=!maximumField||maximumField.value===''?null:cleanAmount(maximumField.value);
      if(maximumField&&maximumField.value!==''&&maxAmount===null){maximumField.setCustomValidity('Enter a valid maximum price');maximumField.reportValidity();return}
      if(minAmount!==null&&maxAmount!==null&&minAmount>maxAmount){
        maximumField?.setCustomValidity('Maximum must be at least the minimum');
        maximumField?.reportValidity();return;
      }
      maximumField?.setCustomValidity('');
      const destination=new URL(window.location.href);
      for(const key of Array.from(destination.searchParams.keys())){
        if(key==='page'||key.startsWith('page_')||key==='ravin_page')destination.searchParams.delete(key);
      }
      for(const key of facetKeys)destination.searchParams.delete(key);
      for(const [key,values] of selected){
        for(const value of values)destination.searchParams.append(key,value);
      }
      if(root.dataset.ravinAvailabilitySupported==='true')destination.searchParams.set('filter.v.availability','1');
      else destination.searchParams.delete('filter.v.availability');
      for(const key of ['filter.v.price.gte','filter.v.price.lte','ravin.price.gte','ravin.price.lte'])destination.searchParams.delete(key);
      if(minAmount!==null){
        destination.searchParams.set('ravin.price.gte',currencyAmount(minAmount));
        destination.searchParams.set('filter.v.price.gte',currencyAmount(minAmount));
      }
      if(maxAmount!==null){
        destination.searchParams.set('ravin.price.lte',currencyAmount(maxAmount));
        const discount=Math.max(0,Math.min(100,Number(root.dataset.ravinMaxDiscount)||0));
        if(discount<100){
          const nativeMax=Math.ceil(maxAmount/(1-discount/100)*100)/100;
          destination.searchParams.set('filter.v.price.lte',currencyAmount(nativeMax));
        }
      }
      if(desiredSort)destination.searchParams.set('sort_by',desiredSort);
      try{window.sessionStorage.setItem('ravin-refine-tab:'+destination.pathname,currentTab)}catch(e){}
      if(destination.toString()===window.location.href){details.open=false;return}
      window.location.assign(destination.toString());
    }

    apply.addEventListener('click',applyFilters,{signal:controller.signal});
    clear.addEventListener('click',()=>{
      for(const values of selected.values())values.clear();
      if(maximumField){maximumField.value='';maximumField.setCustomValidity('')}
      if(minimumField)minimumField.value='';
      if(rangeField)rangeField.value=rangeField.max;
      dirty=true;renderSummary();
    },{signal:controller.signal});
    root.dataset.refineReady='true';
    setTab(currentTab);
    const hasNativeActive=Array.from(selected.values()).some(x=>x.size>0)||baseMax!==null||baseMin!==null;
    if(hasNativeActive)details.open=true;
    renderSummary();
    instances.set(root,()=>{controller.abort();instances.delete(root)});
  }
  function initScope(scope){
    if(scope.matches?.('ravin-filters'))init(scope);
    scope.querySelectorAll?.('ravin-filters').forEach(init);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initScope(document),{once:true});
  else initScope(document);
  document.addEventListener('shopify:section:load',event=>initScope(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    if(event.target.matches?.('ravin-filters'))instances.get(event.target)?.();
    event.target.querySelectorAll?.('ravin-filters').forEach(root=>instances.get(root)?.());
  });
})();